import { render, staticRenderFns } from "./PaypalPayLaterMessage.vue?vue&type=template&id=674b198d&scoped=true"
import script from "./PaypalPayLaterMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaypalPayLaterMessage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaypalPayLaterMessage.vue?vue&type=style&index=0&id=674b198d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b198d",
  null
  
)

export default component.exports